import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface CreateSchedulePayload {
  analysis_id: number;
  analysis_query: string;
  frequency: 'hourly' | 'daily' | 'weekly';
  time: string;
  day: string | null;
  next_run: string;
  subscribers: string[];
  is_internal?: boolean;
}

const createScheduleSavedAnalysis = async (data: CreateSchedulePayload): Promise<any> => {
  const response = await instance.post('/nexa/schedule/create', { schedule: data });
  return response.data;
};

export const useCreateScheduleSavedAnalysis = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createScheduleSavedAnalysis,
    onSuccess: (data) => {
      message.success(data?.message || 'Schedule created successfully');
      queryClient.invalidateQueries(['nexa-schedule-list']);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || 'Failed to create schedule');
    },
  });
};
